export class Culture
{

    static DATETIME_FORMAT = 'd. M. H:mm';

    static DATE_FORMAT = 'd. M.';

    static TIME_FORMAT = 'H:mm';


    public static dateTime(dateTime: string): string
    {
        const dt = kendo.parseDate(dateTime);
        return kendo.toString(dt, Culture.DATETIME_FORMAT);
    }

}